import styled from 'styled-components';
import { Text24Bold } from '../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  max-height: 100dvh;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 768px) {
    max-height: calc(100dvh - 5.6rem);
  }
`;

export const Title = styled(Text24Bold)`
  letter-spacing: -0.408px;
  margin-left: 1.6rem;
  margin-bottom: 2.4rem;
`;

export const Navigator = styled.nav`
  display: flex;
  flex-direction: column;
  padding: 2.4rem 0;
  min-width: 38rem;
  border-right: 1px solid #f3f4f6;
  background-color: #fff;

  @media screen and (max-width: 1100px) {
    max-width: 55rem;
  }

  @media screen and (max-width: 900px) {
    max-width: 25rem;
    min-width: 25rem;
  }

  @media screen and (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
    border-right: none;
  }
`;

export const Content = styled.div`
  overflow: scroll;
  width: 100%;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 5.6rem);
`;

export const InfiniteScrollMarker = styled.div`
  height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListContainer = styled.div`
  overflow: auto;
  height: calc(100% - 5.6rem);
  display: flex;
  flex-direction: column;
`;

export const RowItem = styled.div`
  padding: 1.6rem 1.6rem 1.6rem 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f3f4f6;
  gap: 1rem;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#EEF5FD' : 'transparent')};
`;

export const PendingContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #e7cfb0;
  background: #ffefdb;
  color: #e98502;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  padding: 0.2rem 0.8rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const ContentHeader = styled.div`
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  padding: 2.4rem 2.4rem 2.4rem 1.2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ContentContainer = styled.div`
  height: calc(100% - 7.9rem - 11.8rem);
  background-color: #eef5fd;
  padding: 2.4rem;
  align-content: flex-end;
  overflow: auto;
`;

export const ContentFooter = styled.div`
  border-top: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.02);
  padding: 1.6rem 2.4rem 0 2.4rem;
  display: flex;
  gap: 1.2rem;
`;

export const YourResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
`;

export const SaveResponseBtn = styled.button`
  border-radius: 16px;
  background: #f5f5f5;
  width: 18.5rem;
  height: 4.8rem;
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: -0.42px;
`;

export const MessageRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $role }) => ($role === 'USER' ? 'flex-start' : 'flex-end')};
  margin-bottom: 16px;
`;

export const RoleLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export const MessageBubble = styled.div`
  background-color: ${({ $role }) => ($role === 'USER' ? '#ffffff' : '#BADAF7')};
  color: #000;
  border-radius: 18px;
  padding: 12px 16px;
  line-height: 1.4;
  position: relative;
  box-shadow: ${({ role }) => (role === 'USER' ? '0 1px 2px rgba(0, 0, 0, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.12)')};
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
`;

export const MessageBubbleRow = styled.div`
  max-width: 75%;
  display: flex;
  align-items: center;
  gap: 1rem;
  svg {
    cursor: pointer;
  }
`;
